let activeDrags = 0;

// Suppress native text/image selection only for the lifetime of a UI drag.
// Interactive controls inside a title bar must keep their normal focus behavior.
exports.beginUiDrag = (event, handle, onCancel) => {
  if ((event.button != null && event.button !== 0) || event.isPrimary === false || event.touches?.length > 1) return null;
  const control = event.target?.closest?.('input, textarea, select, button, a, [contenteditable]:not([contenteditable="false"]), [role="button"], [role="switch"], [role="checkbox"]');
  if (control && control !== handle && handle.contains(control)) return null;
  if (event.cancelable) event.preventDefault();
  window.getSelection()?.removeAllRanges();
  activeDrags += 1;
  document.documentElement.classList.add('ui-pointer-dragging');
  let finished = false;
  let cancel;
  const finish = () => {
    if (finished) return;
    finished = true;
    window.removeEventListener('blur', cancel);
    activeDrags -= 1;
    if (!activeDrags) document.documentElement.classList.remove('ui-pointer-dragging');
  };
  cancel = () => { finish(); onCancel?.(); };
  window.addEventListener('blur', cancel);
  return finish;
};
